/* eslint-disable no-undef */
import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Layout from '../../components/global/layout';
import Feature from '../../components/global/feature';
import GeneralContent from '../../components/global/general-content';

import SEO from '../../components/global/seo';

const IndexPage = ({ data }) => {
  // const interactiveData = data.interactive.nodes[0].unResolvedMicroInteractive;
  /* eslint-disable operator-linebreak */
  const templateGlobals =
    data.interactive.nodes[0].unResolvedMicroTemplateGlobals;
  /* eslint-disable operator-linebreak */
  const relatedItems = templateGlobals.relatedContentItems;
  const hero = {
    type: templateGlobals.heroImageType,
    title: templateGlobals.heroImageTitle,
    subhead: templateGlobals.heroImageSubhead,
    heroImage: templateGlobals.heroImage,
    heroVideo: templateGlobals.loopingVideoMp4,
    heroVideoWebm: templateGlobals.loopingVideoWebm,
    applePodcastsUrl: templateGlobals.heroImageApplePodcastsUrl,
    spotifyUrl: templateGlobals.heroImageSpotifyUrl,
    generalCta: templateGlobals.heroImageGeneralCta,
  };
  const feature = {
    featureTypeOfFeature: templateGlobals.featureTypeOfFeature,
    featureImage: templateGlobals.featureImage,
    featureEmbed: templateGlobals.featureEmbed,
    featureDescription: templateGlobals.featureDescription,
  };
  const content = templateGlobals.generalContent;

  return (
    <Layout hero={hero} relatedItems={relatedItems}>
      <SEO
        title={`Un(re)solved | FRONTLINE | PBS | ${hero.title}`}
        description={(templateGlobals.metaDescription ? templateGlobals.metaDescription : '')}
      />
      {(feature.featureImage || feature.featureEmbed || feature.featureDescription) ?
        <Feature feature={feature} />
        : false}
      <GeneralContent content={content} />

      {/* JSON.stringify(relatedItems) */}
    </Layout>
  );
};

export const query = graphql`
  {
    interactive: allWpInteractive(filter: { slug: { eq: "curriculum" } }) {
      nodes {
        unResolvedMicroTemplateGlobals {
          heroImageType
          heroImageTitle
          heroImageSubhead
          loopingVideoMp4 {
              mediaItemUrl
          }
          loopingVideoWebm {
              mediaItemUrl
          }
          heroImage {
            localFile {
              childrenImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          heroImageApplePodcastsUrl
          heroImageSpotifyUrl
          heroImageGeneralCta {
            target
            title
            url
          }
          generalContent
          featureTypeOfFeature
          featureLink {
            target
            title
            url
          }
          featureImage {
            localFile {
              childrenImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          featureEmbed
          featureDescription
          metaDescription
          relatedContentItems {
            image {
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            link {
              target
              title
              url
            }
          }
        }
      }
    }
  }
`;

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default IndexPage;
